import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in en.industries.medical-devices.index.tsx. Without this wrapper the
// page component would shadow every nested child route.
export const Route = createFileRoute("/en/industries/medical-devices")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
